import { ThemeProperties } from '../../../core';

export interface InputRadioTheme {
	focusColor: string;
	labelMarginBottom: string;

	itemsGap: string;
	itemsMargin: string;
	outlinedItemsGap: string;

	itemFont: string;
	itemTextColor: string;
	itemGap: string;
	itemsHorizontalGap: string;

	indicatorBackground: string;
	indicatorBorderColor: string;
	indicatorOuterSize: string;
	indicatorInnerSize: string;

	activeIndicatorOutlineColor: string;

	checkedItemFont: string;
	checkedIndicatorBorderColor: string;

	outlinedItemPadding: string;
	outlinedItemMinHeight: string;
	outlinedItemBorderColor: string;
	outlinedItemBorderRadius: string;

	hoverOutlinedItemBorderColor: string;

	checkedOutlinedItemBackground: string;

	activeOutlinedItemOutlineColor: string;

	disabledOutlinedItemBackground: string;
	disabledIndicatorBorderColor: string;
	disabledIndicatorBackground: string;
}

export const theme = new ThemeProperties('inputRadio');
